import { cn } from "@/lib/utils";

/** The numbered pill that walks a shopper through the configurator top to bottom. */
export function SectionNumber({ n, className }: { n: number; className?: string }) {
  return (
    <span
      aria-hidden
      className={cn(
        "inline-flex size-7 shrink-0 items-center justify-center rounded-full bg-brand text-sm font-medium text-white",
        className,
      )}
    >
      {n}
    </span>
  );
}
